import { Directive, ElementRef, AfterContentInit, Renderer2, ContentChildren, QueryList } from '@angular/core';
import { startWith } from 'rxjs/operators';

@Directive({
  selector: '[appAnimateStagger]',
  standalone: true,
})
export class AnimateStaggerDirective implements AfterContentInit {

  @ContentChildren('staggerItem', { read: ElementRef }) items!: QueryList<ElementRef>;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.el.nativeElement, 'stagger-container');
  }

  ngAfterContentInit(): void {
    this.items.changes.pipe(
      startWith(this.items) // Ensure the animation runs on the initial list
    ).subscribe((list: QueryList<ElementRef>) => {
      this.animateItems(list.toArray());
    });
  }

  private animateItems(items: ElementRef[]): void {
    items.forEach((item: ElementRef, index: number) => {
      this.renderer.addClass(item.nativeElement, 'stagger-item');
      // Use a timeout to ensure the initial (invisible) state is applied before adding the visible class
      setTimeout(() => {
        this.renderer.setStyle(item.nativeElement, 'transition-delay', `${index * 80}ms`);
        this.renderer.addClass(item.nativeElement, 'is-visible');
      }, 50);
    });
  }
}
